// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__9gCSr","spinner":"SmallLoader_spinner__aRf-F","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__Au92z"};